import React, { useState } from 'react';
import { MessageCircle, X, Send, Mail, Phone } from 'lucide-react';
import { toast } from 'react-hot-toast';

const SUPPORT_EMAIL = 'support@travistechrepair.com';
const SUPPORT_PHONE = '850-273-8264';

export default function LiveSupport() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim()) return;

    // Open default email client with support email
    const emailSubject = 'Live Support Request';
    const emailBody = message;
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    
    toast.success('Opening email client...');
    setMessage('');
    setIsOpen(false);
  };

  const handleCallSupport = () => {
    window.location.href = `tel:${SUPPORT_PHONE}`;
    toast.success('Initiating call...');
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen ? (
        <div className="bg-white rounded-lg shadow-2xl w-80">
          <div className="p-4 bg-primary text-white rounded-t-lg flex justify-between items-center">
            <h3 className="font-semibold">Live Support</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-200 transition-colors"
            >
              <X size={20} />
            </button>
          </div>
          
          <div className="p-4">
            {/* Contact Options */}
            <div className="mb-4 space-y-3">
              <button
                onClick={handleCallSupport}
                className="w-full flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
              >
                <Phone size={18} />
                <span>Call Support: {SUPPORT_PHONE}</span>
              </button>
              
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="w-full flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                <Mail size={18} />
                <span>Email: {SUPPORT_EMAIL}</span>
              </a>
            </div>

            {/* Message Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Send us a message:
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="How can we help you today?"
                  className="w-full p-2 border-2 border-gray-200 rounded-md focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
                  rows={4}
                />
              </div>
              <button
                type="submit"
                className="w-full bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors flex items-center justify-center gap-2"
              >
                <Send size={18} />
                Send Message
              </button>
            </form>

            <div className="mt-4 text-center text-sm text-gray-500">
              <p>Available Mon-Fri: 9:00 AM - 8:00 PM</p>
              <p>Sat: 10:00 AM - 2:00 PM</p>
            </div>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-primary text-white p-4 rounded-full shadow-lg hover:bg-primary/90 transition-colors"
        >
          <MessageCircle size={24} />
        </button>
      )}
    </div>
  );
}